export const styles = (theme) => ({
  selectedMenuLabel: {
    fontSize: "20px",
    fontWeight: "800",
    letterSpacing: "0.25px",
    color: "#4a90e2",
  },
});
export default styles;
